module.exports = __webpack_public_path__ + "static/media/lost_girls.7d1a29c2.jpeg";